import { useLocation } from "react-router-dom";
import { environment } from "../environment";
import { SHOP_SOURCES } from "./constants/shopSources";

export const getFullPath = (location) => location.pathname + location.search;

export const useDetailPageQuery = (idQueryKey = null) => {
    const location = useLocation();

    if (!idQueryKey) return location.search.slice(1);

    const queryParams = new URLSearchParams(location.search);
    let source = queryParams.has("source") ? queryParams.get("source") : null;

    if (!source || !Object.values(SHOP_SOURCES).includes(source)) source = SHOP_SOURCES.JCR; // Defaults to JCR

    return {
        id: queryParams.has(idQueryKey) ? queryParams.get(idQueryKey) : null,
        source,
    };
};

export const useIsHomePage = () => {
    const location = useLocation();

    return location.pathname === environment.APP_BASE;
};
